<template>
  <div class="brands-content">
    <el-input v-model="searchVal" :placeholder="$t('client.site.clientName')" @input="inputSearch"
      @keyup.enter.native="handleSearchVal" prefix-icon="el-icon-search" size="medium"></el-input>

    <div class="brands-list">
      <ul class="treeScrollBar" v-if="filterList.length > 0">
        <li v-for="(item, index) in filterList" :key="item.id" :class="{ 'active': currentIndex === index }" :title="item.brandName"
          @click="clickBrandName(item, index)">{{ item.brandName }}</li>
      </ul>
      <div class="none-data" v-else>{{ $t('common.nodata') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: [],
    activeIndex: 0,
  },
  data() {
    return {
      filterList: [],
      currentIndex: 0,
      searchVal: ''
    }
  },
  mounted() {
    this.filterList = this.dataList
    this.currentIndex = this.activeIndex;
  },
  watch: {
    dataList(newVal) {
      this.filterList = newVal
    },
    activeIndex(newVal) {
      this.currentIndex = newVal;
    }
  },
  methods: {
    inputSearch(val) {
      this.filterList = [];
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].brandName.indexOf(val) !== -1) {
          this.filterList.push(this.dataList[i]);
        }
      }
      if (!val) {
        this.currentIndex = 0;
        this.$emit("clickSide", this.filterList[0], 0, this.filterList);
      } else {
        this.currentIndex = -1
      }
    },
    handleSearchVal() {
      if (this.filterList.length > 0) {
        this.currentIndex = 0;
        this.$emit("clickSide", this.filterList[0], 0, this.filterList);
      }
    },
    clickBrandName(item, index) {
      this.currentIndex = index;
      this.$emit("clickSide", item, index, this.filterList);
    },
  }
}
</script>

<style scoped lang="scss">
.brands-content {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: #F8F8F8;
  padding: 24px 10px;
  border-radius: 2px;
  
  .brands-list {
    width: 100%;
    height: 100%;
    padding-top: 20px;
    box-sizing: border-box;

    ul {
      max-height: 750px;
      overflow-y: auto;

      li {
        flex-shrink: 0;
        position: relative;
        padding-left: 23px;
        line-height: 48px;
        box-sizing: border-box;
        font-size: 14px;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
        cursor: pointer;
        color: #5B647D;

        &.active {
          color: #0B73F6;
        }

        &:hover {
          background: #F6F6F6;
        }
      }
    }
  }
}
</style>
